(function () {
  var STYLE_ATTR = "data-sbb-giftpro";
  var HOST = "gp-product-choice-popup";
  var cssText = "";
  var watched = typeof WeakSet === "function" ? new WeakSet() : null;

  function inject(root) {
    if (!root || !cssText) return;
    var style = root.querySelector("style[" + STYLE_ATTR + "]");
    if (!style) {
      style = document.createElement("style");
      style.setAttribute(STYLE_ATTR, "");
      root.appendChild(style);
    }
    if (style.textContent !== cssText) style.textContent = cssText;
  }

  function enhance(host) {
    if (!host || (watched && watched.has(host))) return;
    if (watched) watched.add(host);
    inject(host.shadowRoot);
    if (host.shadowRoot && typeof MutationObserver === "function") {
      new MutationObserver(function () {
        inject(host.shadowRoot);
      }).observe(host.shadowRoot, { childList: true });
    }
  }

  function scan(node) {
    if (!node) return;
    if (node.nodeType === 9) {
      scan(node.documentElement);
      return;
    }
    if (node.nodeType !== 1) return;
    if (node.localName === HOST) enhance(node);
    if (node.querySelectorAll) node.querySelectorAll(HOST).forEach(enhance);
  }

  function mergeDesignCss() {
    var current = window.popupDesign;
    var design = current;
    if (typeof current === "string") {
      try {
        design = JSON.parse(current);
      } catch (e) {
        design = {};
      }
    }
    if (!design || typeof design !== "object") design = {};
    var existing = design.customCss || "";
    if (existing.indexOf("sbb-giftpro") === -1) {
      design.customCss = "/* sbb-giftpro */\n" + cssText + (existing ? "\n" + existing : "");
      window.popupDesign = design;
    }
  }

  function boot(css) {
    cssText = css || "";
    if (!cssText) return;
    mergeDesignCss();
    scan(document);
    if (typeof MutationObserver === "function") {
      new MutationObserver(function (records) {
        records.forEach(function (record) {
          record.addedNodes.forEach(scan);
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  var link = document.querySelector('link[href*="giftpro-popup"]');
  if (!link || !link.href) return;

  fetch(link.href)
    .then(function (response) {
      return response.ok ? response.text() : "";
    })
    .then(boot)
    .catch(function () {
      boot("");
    });
})();
